export const isLocalEnvironment =
	process.env.NODE_ENV === 'development' &&
	/localhost|127\.0\.0\.1|.test/.test(window.location.hostname);
